const ROUND = 'stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"';

export const ENRACINE_MARK =
  `<path d="M12 18V10M12 13 7.2 8.2M12 12.4 16.8 7.6M12 10V5.6M12 18c-1.2 1.9-3.4 2.9-6.6 3.2M12 18c1.2 1.9 3.4 2.9 6.6 3.2M12 18v3.6" fill="none" ${ROUND} stroke-width="2"/>` +
  '<circle cx="6.6" cy="7.4" r="2.3" fill="currentColor"/>' +
  '<circle cx="17.4" cy="6.8" r="2.3" fill="currentColor"/>' +
  '<circle cx="12" cy="4.2" r="2.3" fill="currentColor"/>';

export const HIBOU_ICON =
  `<path d="M5.2 9.5 6.4 3.6l3.8 3.1q1.8-.5 3.6 0l3.8-3.1 1.2 5.9q.9 10.6-6.8 11.4-7.7-.8-6.8-11.4z" fill="none" ${ROUND} stroke-width="1.8"/>` +
  '<circle cx="9.1" cy="11.2" r="2.6" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
  '<circle cx="14.9" cy="11.2" r="2.6" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
  '<circle cx="9.1" cy="11.2" r="1.1" fill="currentColor"/>' +
  '<circle cx="14.9" cy="11.2" r="1.1" fill="currentColor"/>' +
  '<path d="M11 14.4h2l-1 2.1z" fill="currentColor"/>';
